import React, { Fragment } from 'react'
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { useDispatch, useSelector } from 'react-redux'
import { obtenerSolicitudesWithStatus } from '../../../redux/SolicitudesDucks'
import { withRouter } from 'react-router-dom'

import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepButton from '@mui/material/StepButton';
import { textAlign } from '@mui/system';

import BorradorSVG from '../../../img/borrador.png';
import NuevasSVG from '../../../img/nuevas.png';
import EnProcesoSVG from '../../../img/enproceso.png';
import EnviadosSVG from '../../../img/enviadas.png';
import AceptadasSVG from '../../../img/aceptadas.png';
import DenegadoSVG from '../../../img/denegadas.png';
import CorreccionSVG from '../../../img/correccion.png';
import './mainComponents.module.css';


const iconos = [BorradorSVG, EnviadosSVG, EnProcesoSVG, CorreccionSVG, DenegadoSVG, AceptadasSVG];
// const pages = ['Borrador','Enviadas', 'En proceso', 'En espera de corrección' ,'Denegado' ,'Aceptadas'];
const pages = ['Borrador', 'Documentos pendientes', 'Enviadas', 'En proceso', 'Aceptadas'];

const NavBar = (props) => {

  const currentUser = useSelector(store => store.Usuario.data)
  const loginIn = localStorage.getItem('user')
  let idUsuario = 0
  if (currentUser) {
    idUsuario = currentUser.user[0].id
  }

  const estilos1 = '2px';
  const estilos0 = '0px';

  const [isActiva1, setIsActiva1] = React.useState(estilos0);
  const [isActiva2, setIsActiva2] = React.useState(estilos0);
  const [isActiva3, setIsActiva3] = React.useState(estilos0);
  const [isActiva4, setIsActiva4] = React.useState(estilos0);
  const [isActiva5, setIsActiva5] = React.useState(estilos0);
  const [isActiva6, setIsActiva6] = React.useState(estilos0);

  const dispatch = useDispatch()
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [activeStep, setActiveStep] = React.useState(0);

  const darkTheme = createTheme({
    palette: {
      mode: 'light',
      primary: {
        main: '#white',
      }
    },
  });

  //ste no se usa
  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleMenuOptionDesk = async (page, index) => {
    setActiveStep(index)
    setAnchorElNav(null);
    let res
    switch (page) {

      case 'Borrador':
        setIsActiva1(estilos1);
        setIsActiva2(estilos0);
        setIsActiva3(estilos0);
        setIsActiva4(estilos0);
        setIsActiva5(estilos0);
        setIsActiva6(estilos0);

        res = await dispatch(obtenerSolicitudesWithStatus({ status: 1, idLogin: idUsuario }))
        props.history.push('/solicitudes')
        return
      case 'Documentos pendientes':
        setIsActiva1(estilos0);
        setIsActiva2(estilos1);
        setIsActiva3(estilos0);
        setIsActiva4(estilos0);
        setIsActiva5(estilos0);
        setIsActiva6(estilos0);

        res = await dispatch(obtenerSolicitudesWithStatus({ status: 7, idLogin: idUsuario }))
        props.history.push('/solicitudes')
        return
      case 'Enviadas':
        setIsActiva1(estilos0);
        setIsActiva2(estilos0);
        setIsActiva3(estilos1);
        setIsActiva4(estilos0);
        setIsActiva5(estilos0);
        setIsActiva6(estilos0);

        res = await dispatch(obtenerSolicitudesWithStatus({ status: 2, idLogin: idUsuario }))
        props.history.push('/solicitudes')
        return
      case 'En proceso':
        setIsActiva1(estilos0);
        setIsActiva2(estilos0);
        setIsActiva3(estilos0);
        setIsActiva4(estilos1);
        setIsActiva5(estilos0);
        setIsActiva6(estilos0);

        res = await dispatch(obtenerSolicitudesWithStatus({ status: 3, idLogin: idUsuario }))
        props.history.push('/solicitudes')
        return
      // case 'En espera de corrección':
      //   setIsActiva1(estilos0);
      //   setIsActiva2(estilos0);
      //   setIsActiva3(estilos0);
      //   setIsActiva4(estilos0);
      //   setIsActiva5(estilos1);
      //   setIsActiva6(estilos0);

      //   res = await dispatch(obtenerSolicitudesWithStatus({ status: 6, idLogin: idUsuario }))
      //   props.history.push('/solicitudes')
      //   return

      // case 'Denegado':
      //   setIsActiva1(estilos0);
      //   setIsActiva2(estilos0);
      //   setIsActiva3(estilos0);
      //   setIsActiva4(estilos0);
      //   setIsActiva5(estilos0);
      //   setIsActiva6(estilos1);

      //   res = await dispatch(obtenerSolicitudesWithStatus({ status: 5, idLogin: idUsuario }))
      //   props.history.push('/solicitudes')
      //   return
      case 'Aceptadas':
        setIsActiva1(estilos0);
        setIsActiva2(estilos0);
        setIsActiva3(estilos0);
        setIsActiva4(estilos0);
        setIsActiva5(estilos1);
        setIsActiva6(estilos0);

        res = await dispatch(obtenerSolicitudesWithStatus({ status: 4, idLogin: idUsuario }))
        props.history.push('/solicitudes')
        return
      default:
        res = await dispatch(obtenerSolicitudesWithStatus({ status: 2, idLogin: idUsuario }))
        props.history.push('/solicitudes')
        return
    }
  }

  const handleCloseNavMenu = async (event) => {
    setAnchorElNav(null);
  };


  return (
    <Fragment>
      <AppBar position="static" className='appBar'>
        <Toolbar disableGutters>
          <div className='row text-center'>
            <div id="logotipoOpcion" style={{ borderWidth: isActiva1, borderBottomStyle: 'ridge', borderColor: 'deepskyblue' }} className='col-4 col-sm-4 col-md-2 col-lg-2 col-xl-2 col-xxl-2 img-hover-zoom--zoom-n-rotate'>
              <button type='button' className='btn botonZoom' onClick={e => handleMenuOptionDesk(pages[0], 0)}>
                <img className="img-fluid" src={iconos[0]}></img>
                <br></br>
                <span className='texts'>{pages[0]}</span>
              </button>
            </div>
            <div id="logotipoOpcion" style={{ borderWidth: isActiva2, borderBottomStyle: 'ridge', borderColor: 'deepskyblue' }} className='col-4 col-sm-4 col-md-2 col-lg-2 col-xl-2 col-xxl-2 img-hover-zoom--zoom-n-rotate'>
              <button type='button' className='btn botonZoom' onClick={e => handleMenuOptionDesk(pages[1], 1)}>
                <img className="img-fluid" src={iconos[1]}></img>
                <br></br>
                <span className='texts'>{pages[1]}</span>
              </button>
            </div>
            <div id="logotipoOpcion" style={{ borderWidth: isActiva3, borderBottomStyle: 'ridge', borderColor: 'deepskyblue' }} className='col-4 col-sm-4 col-md-2 col-lg-2 col-xl-2 col-xxl-2 img-hover-zoom--zoom-n-rotate'>
              <button type='button' className='btn botonZoom' onClick={e => handleMenuOptionDesk(pages[2], 2)}>
                <img className="img-fluid" src={iconos[2]}></img>
                <br></br>
                <span className='texts'>{pages[2]}</span>
              </button>
            </div>
            <div id="logotipoOpcion" style={{ borderWidth: isActiva4, borderBottomStyle: 'ridge', borderColor: 'deepskyblue' }} className='col-4 col-sm-4 col-md-2 col-lg-2 col-xl-2 col-xxl-2 img-hover-zoom--zoom-n-rotate'>
              <button type='button' className='btn botonZoom' onClick={e => handleMenuOptionDesk(pages[3], 3)}>
                <img className="img-fluid" src={iconos[3]}></img>
                <br></br>
                <span className='texts'>{pages[3]}</span>
              </button>
            </div>
            <div id="logotipoOpcion" style={{ borderWidth: isActiva5, borderBottomStyle: 'ridge', borderColor: 'deepskyblue' }} className='col-4 col-sm-4 col-md-2 col-lg-2 col-xl-2 col-xxl-2 img-hover-zoom--zoom-n-rotate'>
              <button type='button' className='btn botonZoom' onClick={e => handleMenuOptionDesk(pages[4], 4)}>
                <img className="img-fluid" src={iconos[4]}></img>
                <br></br>
                <span className='texts'>{pages[4]}</span>
              </button>
            </div>
            <div id="logotipoOpcion" style={{ borderWidth: isActiva6, borderBottomStyle: 'ridge', borderColor: 'deepskyblue' }} className='col-4 col-sm-4 col-md-2 col-lg-2 col-xl-2 col-xxl-2 img-hover-zoom--zoom-n-rotate'>
              <button type='button' className='btn botonZoom' onClick={e => handleMenuOptionDesk(pages[5], 5)}>
                <img className="img-fluid" src={iconos[5]}></img>
                <br></br>
                <span className='texts'>{pages[5]}</span>
              </button>
            </div>
          </div>
        </Toolbar>
      </AppBar>
      <br />
    </Fragment>
  );
};


export default withRouter(NavBar)
